export function compressCanvasToDataURL(
  canvas,
  type = 'image/jpeg',
  maxSizeKB = 1024,
  initialQuality = 0.8,
  minQuality = 0.1
) {
  if (type === 'image/png') {
    type = 'image/jpeg'
  }

  let quality = initialQuality
  let dataURL = canvas.toDataURL(type, quality)

  const sizeKB = getDataURLSizeKB(dataURL)
  console.log(`Image compression: initial size ${sizeKB.toFixed(1)}KB, target: ${maxSizeKB}KB`)

  if (sizeKB <= maxSizeKB) {
    console.log(`Image already small enough at ${sizeKB.toFixed(1)}KB`)
    return dataURL
  }

  let minQ = minQuality
  let maxQ = quality
  let bestDataURL = dataURL

  let iterations = 0
  const maxIterations = 10

  while (maxQ - minQ > 0.01 && iterations < maxIterations) {
    quality = (minQ + maxQ) / 2
    dataURL = canvas.toDataURL(type, quality)
    const currentSizeKB = getDataURLSizeKB(dataURL)

    if (currentSizeKB <= maxSizeKB) {
      bestDataURL = dataURL
      minQ = quality
    } else {
      maxQ = quality
    }

    iterations++
  }

  const finalSizeKB = getDataURLSizeKB(bestDataURL)
  console.log(
    `Image compressed from ${sizeKB.toFixed(1)}KB to ${finalSizeKB.toFixed(1)}KB ` +
    `(${((1 - finalSizeKB / sizeKB) * 100).toFixed(1)}% reduction)`
  )

  return bestDataURL
}

function getDataURLSizeKB(dataURL) {
  const base64 = dataURL.split(',')[1]
  return (base64.length * 0.75) / 1024
}

export function resizeCanvasIfNeeded(canvas, maxWidth = 1200, maxHeight = 1200) {
  if (canvas.width <= maxWidth && canvas.height <= maxHeight) {
    return canvas
  }

  const aspectRatio = canvas.width / canvas.height
  let newWidth = canvas.width
  let newHeight = canvas.height

  if (canvas.width > maxWidth) {
    newWidth = maxWidth
    newHeight = maxWidth / aspectRatio
  }

  if (newHeight > maxHeight) {
    newHeight = maxHeight
    newWidth = maxHeight * aspectRatio
  }

  const resizedCanvas = document.createElement('canvas')
  resizedCanvas.width = newWidth
  resizedCanvas.height = newHeight

  const ctx = resizedCanvas.getContext('2d')

  ctx.imageSmoothingEnabled = true
  ctx.imageSmoothingQuality = 'high'

  ctx.drawImage(canvas, 0, 0, newWidth, newHeight)

  return resizedCanvas
}
